import { paymentPath, paymentLabel, money } from '../../utils/directPayment';
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_orders } from "../../store/reducers/orderReducer";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { formatCurrency, fetchExchangeRates } from "../../utils/currencyUtils";
import api from "../../api/api";
const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { myOrders } = useSelector((state) => state.order);
  const [state, setState] = useState("all");
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [exchangeLoaded, setExchangeLoaded] = useState(false);

  useEffect(() => {
    dispatch(get_orders({ status: state, customerId: userInfo.id }));
    fetchExchangeRates().then(() => setExchangeLoaded(true));
  }, [state]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (userInfo && userInfo.id) {
        try {
          const { data } = await api.get("/account/get-details");
          if (data.currency) {
            setCurrencyCode(data.currency);
          }
        } catch (error) {
          console.error("Error fetching user currency:", error);
        }
      }
    };
    fetchUserDetails();
  }, [userInfo]);

  const redirect = (ord) => {
    let items = 0;
    for (let i = 0; i < ord.products.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate(paymentPath(ord), {
      state: {
        price: ord.price + (ord.shipping_fee || 0),
        items,
        orderId: ord._id,
        name: ord.shippingInfo.name
      },
    });
  };

  return (
    <div className="bg-[#070707] p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-white">My Orders</h2>
        <Select value={state} onValueChange={(value) => setState(value)}>
          <SelectTrigger className="w-max text-white font-semibold px-5 h-[40px] ">
            <SelectValue placeholder="--order status--" />
          </SelectTrigger>
          <SelectContent className="nex_drop">
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="placed">Placed</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="cancelled">Cancelled</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="pt-4">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-white">
            <thead className="text-xs text-white uppercase bg-[#070707]">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Order Id
                </th>
                <th scope="col" className="px-6 py-3">
                  Price
                </th>
                <th scope="col" className="px-6 py-3">
                  Payment status
                </th>
                {/* <th scope="col" className="px-6 py-3">
                  Order status
                </th> */}
                <th scope="col" className="px-6 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {myOrders.map((o, i) => (
                <tr key={i} className="bg-[#070707] text-muted-foreground">
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {o._id}
                  </td>
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {o.payment_method === 'manual_bank_transfer' ? money(Math.round((o.price + (o.shipping_fee || 0)) * 100)) : formatCurrency(o.price, currencyCode, o.products && o.products[0] && o.products[0].currency ? o.products[0].currency : 'USD')}
                  </td>
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {paymentLabel(o.payment_status)}{o.payment_method === "manual_bank_transfer" && <span className="block text-xs">Bank transfer to merchant</span>}
                  </td>
                  {/* <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {o.delivery_status}
                  </td> */}
                  <td className="px-6 py-4">
                    <Link to={`/dashboard/order/details/${o._id}`}>
                      <span className="bg-white text-black text-xs whitespace-nowrap font-bold mr-2 px-4 py-1 rounded">
                        view
                      </span>
                    </Link>
                    {(o.payment_method === "manual_bank_transfer" || o.payment_status !== "paid") && (
                      <span
                        onClick={() => redirect(o)}
                        className="whitespace-nowrap cursor-pointer bg-white text-black text-xs font-bold mr-2 px-4 py-1 rounded"
                      >
                        View payment
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Orders;
